import { ApiBillingAddress } from 'api/types/ApiBillingAddress';
import { BackgroundTask, waitTaskCompleted } from 'utils/asyncBackendTask';
import { postJson } from 'utils/http/postJson';

export type UTMParams = {
  utmSource?: string;
  utmMedium?: string;
  utmCampaign?: string;
  utmTerm?: string;
  utmContent?: string;
};
export type CreditCard = {
  stripeTokenId: string;
  methodId: string;
};
export type Donation = ApiBillingAddress &
  UTMParams & {
    sfCampaignId?: string;
    amount: string;
    otherAmount: string;
    firstName: string;
    gift: boolean;
    lastName: string;
    email: string;
    phone: string;
    sendEmails: true;
    note: string;
  };
export type DonationPayload = Donation & CreditCard;

type DonationResult = {
  success: boolean;
  invoiceIds?: Array<string>;
  errorHuman?: string;
  error?: {
    msg: string;
    stripeCode: string;
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function createDonation(donation: any, token: any) {
  return postJson(`/data/website/donate`, { ...donation, token }).then(
    // @ts-expect-error TS(2345): Argument of type '({ task }: { task: any; }) => an... Remove this comment to see the full error message
    ({ task }) => task,
  );
}

function handleStripeBackgroundTask(task: BackgroundTask<DonationResult>) {
  return waitTaskCompleted(task);
}

export function makeDonation(values: DonationPayload) {
  const { stripeTokenId, methodId, ...donation } = values;
  return (
    createDonation(donation, stripeTokenId)
      // @ts-expect-error TS(2345): Argument of type 'unknown' is not assignable to pa... Remove this comment to see the full error message
      .then((task) => handleStripeBackgroundTask(task))
      .then((result) => result)
  );
}
